import { useMutation, useQueryClient } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import axios from "axios";

const renameTC = async ({ id, newName }) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios
    .get(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=changetcname&companyid=${user.companyid}&tcid=${id}&tcname=${newName}`,
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error.response.data.error);
    });

  return response;
};

const useRenameTCQuery = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: renameTC,
    onSuccess: () => {
      queryClient.invalidateQueries(["testCaseResults", "searchTCSearch"]);
    },
    onError: (error) => {
      console.log("Error uploading file", error.message);
    },
  });
};

export default useRenameTCQuery;
